import { Toast, ToastBody } from "reactstrap";
import { Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { PlacementToastContentProp } from "../../../../Type/BonusUi";

export const PlacementToastContent = ({ data }: PlacementToastContentProp) => {
  return (
    <div className="bg-light position-relative bd-example-toasts">
      <div className={`toast-container p-3 position-absolute ${data}`}>
        <Toast fade>
          <div className="toast-header toast-img">
            <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
            <strong className="me-auto">Boho theme</strong>
            <small className="d-sm-block d-none">25 min ago</small>
          </div>
          <ToastBody className="toast-dark txt-dark">
            <P className="toast-content"><em className="txt-danger">Attackers</em> on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations.</P>
          </ToastBody>
        </Toast>
      </div>
    </div>
  );
};
